// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"296":"ea88be26","7538":"recorder","9983":"profiler"}[chunkId] + "." + {"296":"9a85b5e70a39c188","7538":"dbb2c6fdcc1358d3","9983":"76da3cfc7466e4cb"}[chunkId] + ".js";
};